<div class="identities-container">
  <nz-collapse nzAccordion class="identity" [nzBordered]="false" [nzExpandIconPosition]="'right'">
    <nz-collapse-panel *ngFor="let identity of identities" [nzHeader]="coverTemplate" [nzExtra]="issuerTemplate"
      [ngClass]="{'no-arrow': identity.status == 'ISSUING' || identity.status == 'CREATED'}"
      [nzActive]="currentActiveIdentityCollapsePanel?.pk == identity.pk || identity.status == 'APPROVED'"
      (click)="setActivePanel(identity)">
      <app-user-identity [user]="user" [identity]="identity" class="identity"
        (chooseActionView)="onChooseAction($event)">
      </app-user-identity>
      <ng-template #coverTemplate>
        <div nz-row [nzJustify]="'space-between'" [nzAlign]="'middle'">
          <div [ngClass]="updateSizeDiv(identity)" nz-col nzFlex="180px">
            <span class="item-name" [style]="updateWhiteSpace(identity)">Identità {{ identity | getIdentityTypeDisplayPipe }}</span>
          </div>
        </div>
      </ng-template>
      <ng-template #issuerTemplate>
        <div nz-row [nzAlign]="'middle'">
          <div class="item-scroll status-name" nz-col nzFlex="212px" [ngSwitch]="identity.status"
            style="width: 212px !important; flex: 0 0 212px !important; max-width: 212px !important;">
            <span class="item-name status waiting"
              *ngSwitchCase="'CREATED'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status active"
              *ngSwitchCase="'APPROVED'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status active"
              *ngSwitchCase="'ISSUING'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status active"
              *ngSwitchCase="'ISSUED'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status revoked"
              *ngSwitchCase="'HOLD'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status revoked"
              *ngSwitchCase="'REVOKED'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status blocked"
              *ngSwitchCase="'EXPIRED'">{{identity.status|getIdentityDisplayStatusPipe}}</span>
            <span class="item-name status" *ngSwitchDefault>...</span>
          </div>
        </div>
      </ng-template>
    </nz-collapse-panel>
  </nz-collapse>
</div>

<!-- <div nz-row *ngIf="isEmpty">
  <div *ngIf="userId" class="sidebox">
    <div nz-row nzJustify="space-between" nzAlign="middle" class="association-wrap">
      <div nz-col nzFlex="auto">
        <span i18n="Identity.Identity.NoIdentity|label for no identities@@Identity.Identity.NoIdentity">
          Nessuna identità associata
        </span>
      </div>
    </div>
  </div>
</div> -->
